import { useState } from 'react';
import type { ReactNode } from 'react';
import KeyboardArrowDownOutlined from '@mui/icons-material/KeyboardArrowDownOutlined';
import { UserDefaultIcon } from '@practium/ui';
import { timeAgo } from '@practium/shared';
import styles from './SupportCardShell.module.css';

interface SupportCardShellProps {
	avatarUrl?: string;
	userName: string;
	subject: string;
	createdAt: Date;
	isExpanded: boolean;
	onExpand: () => void;
	timeAgoClassName?: string;
	headerActions?: ReactNode;
	preview?: string;
	expandedContent?: ReactNode;
}

export const SupportCardShell = ({
	avatarUrl,
	userName,
	subject,
	createdAt,
	isExpanded,
	onExpand,
	timeAgoClassName,
	headerActions,
	preview,
	expandedContent,
}: SupportCardShellProps) => {
	const [imageError, setImageError] = useState(false);

	return (
		<div className={styles.card}>
			<div className={styles.top}>
				<div className={styles.topInfo}>
					{avatarUrl && !imageError ? (
						<img
							className={styles.avatar}
							src={avatarUrl}
							alt={userName}
							onError={() => setImageError(true)}
						/>
					) : (
						<div className={styles.avatarFallback}>
							<UserDefaultIcon className={styles.avatarFallbackIcon} />
						</div>
					)}
					<div className={styles.subjectGroup}>
						<span className={styles.subject}>{subject}</span>
						<span className={`${styles.timeAgo} ${timeAgoClassName ?? ''}`}>{timeAgo(createdAt)}</span>
					</div>
				</div>
				<div className={styles.topActions}>
					<span className={styles.userName}>{userName}</span>
					<div className={styles.actions}>
						{headerActions}
						<button
							type="button"
							className={styles.actionBtn}
							onClick={onExpand}
							aria-label={isExpanded ? 'Recolher' : 'Expandir'}
						>
							<KeyboardArrowDownOutlined
								className={`${styles.actionIcon} ${isExpanded ? styles.actionIconExpanded : ''}`}
							/>
						</button>
					</div>
				</div>
			</div>

			{!isExpanded && preview && (
				<div className={styles.bottom}>
					<span className={styles.dot} />
					<p className={styles.preview}>{preview}</p>
				</div>
			)}

			{isExpanded && expandedContent}
		</div>
	);
};
